







































































import Vue from 'vue';
import { IPartnerShopInformation } from '@/common/interfaces/partnershop.interface';
import A11yHelper from '@/helpers/A11yHelper';
import { IMenuItem } from '@/common/interfaces/header.interface';
import AppHelper from '../../../helpers/AppHelper';
import Dropdown from './Dropdown.vue';
import PartnerShopMethods from '../../../methods/PartnerShopMethods';
import PartnerShopHelper from '../../../helpers/page-specific/PartnerShopHelper';

interface ITopicComponent {
  AppHelper: typeof AppHelper;
  keyboardNavigation: {
    menuToShow: string | null;
    show: boolean;
  };
  partnerShopInformation: IPartnerShopInformation;
}

export default Vue.extend({
  name: `Topic`,
  components: { Dropdown },
  data(): ITopicComponent {
    return {
      AppHelper,
      keyboardNavigation: {
        menuToShow: null,
        show: false,
      },
      partnerShopInformation: PartnerShopHelper.getInitialPartnerShopData(),
    };
  },
  props: {
    isPartnerShop: {
      required: true,
      type: Boolean,
    },
    topics: {
      required: true,
      type: Array as () => IMenuItem[],
    },
  },
  mounted(): void {
    this.checkForPartnerShop();
  },
  methods: {
    ...PartnerShopMethods,
    closeDropdown(hide: boolean): void {
      if(hide) {
        this.keyboardNavigation = {
          menuToShow: null,
          show: false,
        };
      }
    },
    focusOut(e: FocusEvent | null): void {
      if(!A11yHelper.isFocusWithinCurrentGroup(e)) {
        this.keyboardNavigation = {
          menuToShow: null,
          show: false,
        };
      }
    },
    toggleMenuViaKeyboard(topic: IMenuItem) {
      this.keyboardNavigation = {
        menuToShow: topic.title,
        show: !this.keyboardNavigation.show,
      };
    },
    /*
     * since we underline every menu item when hovering over the border box surrounding it
     * this helper function is needed to handle the clicking of a top level link when the
     * cursor is not directly on top of the a href but on the box around it
     *
     * target is typed as EventTarget which only has event listener functions - it is type HTMLElement as well though so casting to one for TS to be happy
     */
    triggerClick(event: PointerEvent): void {
      if(event.target && (event.target as HTMLElement).classList.contains(`topic__entry--link`)) {
        (event.target as HTMLElement).querySelector(`a`)?.click();
      }
    },
  },
});
